import { Grid, IconButton } from '@mui/material';
import Stack from '@mui/material/Stack/Stack';
import { ReactNode, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { WebSocketContext } from '../../../../contexts/WebSocketContext';
import { useCurrentTime } from '../../../../hooks/useCurrentTime';
import { useGameFeature } from '../../../../hooks/useGameFeature';
import { GameType as GameTypeEnum } from '../../../../models/games/enums/GameType';
import { ROUTE_NEW_UI } from '../../../../models/Route';
import { getMainUserState } from '../../../main/selector';
import { routeSliceActions } from '../../../routeController/slice';
import { getLobbyStateHallGameTypeMap } from '../../selector';
import './NewUIPopup.scss';
import { PopupCloseIcon } from './PopupCloseIcon';

const READ_STRING = 'read';
type Notice = {
    key: string;
    startTime: number;
    endTime: number;
    image: string;
    langs: Array<string>;
};
const notices = [
    {
        key: 'thai_hilo',
        startTime: 1739190600000,
        endTime: 1739709000000,
        image: 'thai_hilo_en.jpg',
        langs: ['th-TH', 'zh-CN', 'zh-TW', 'ko-KR'],
    },
    {
        key: 'bacc_sidebet',
        startTime: 1741609800000,
        endTime: 1742128200000,
        image: 'en.jpg',
        langs: ['th-TH', 'zh-CN', 'zh-TW', 'ko-KR'],
    },
] as Array<Notice>;
export const NewUIPopup = () => {
    const { i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const [currentNotice, setCurrentNotice] = useState<Notice>();
    // const [isChecked, setIsChecked] = useState(false);
    const [image, setImage] = useState<ReactNode>(<></>);
    const { currentTimeStamp } = useCurrentTime();
    const { Username } = useSelector(getMainUserState);
    const dispatch = useDispatch();
    const { haveBaccSideBet } = useGameFeature();
    const hostList = useSelector(getLobbyStateHallGameTypeMap);
    const {
        hasLogin: { current },
    } = useContext(WebSocketContext);
    const havePermission = (key: string) => {
        if (key === 'thai_hilo') {
            if (
                hostList.find(host => host.gameType === GameTypeEnum.ThaiHiLo)
            ) {
                return true;
            }
            hostList.forEach(v => {
                if (v.gameType === GameTypeEnum.ThaiHiLo) {
                    return true;
                }
            });
        } else if (key === 'bacc_sidebet') {
            return haveBaccSideBet;
        }
        return false;
    };
    useEffect(() => {
        if (current && hostList && haveBaccSideBet !== undefined) {
            for (let i = 0; i < notices.length; i++) {
                let n = notices[i];
                const isShowed =
                    localStorage.getItem(`${n.key}_${Username}`) == 'read';
                if (isShowed) continue;
                if (
                    currentTimeStamp() >= n.startTime &&
                    currentTimeStamp() < n.endTime
                ) {
                    if (havePermission(n.key)) {
                        setCurrentNotice(n);
                    }
                    break;
                }
            }
        }
    }, [current, hostList, haveBaccSideBet]);
    useEffect(() => {
        if (currentNotice) {
            let path = `${process.env.PUBLIC_URL}/resource/assets/image/new_ui/${currentNotice.image}`;
            if (currentNotice.langs.indexOf(i18n.language) >= 0) {
                switch (i18n.language) {
                    case 'th-TH':
                        path = path.replace('en.', 'th.');
                        break;
                    case 'ko-KR':
                        path = path.replace('en.', 'kr.');
                        break;
                    case 'vi-VN':
                        path = path.replace('en.', 'vn.');
                        break;
                    case 'zh-CN':
                        path = path.replace('en.', 'sc.');
                        break;
                    case 'zh-TW':
                        path = path.replace('en.', 'tc.');
                        break;
                    case 'ms-MY':
                        path = path.replace('en.', 'my.');
                        break;
                    case 'id-ID':
                        path = path.replace('en.', 'in.');
                        break;
                    case 'ja-JP':
                        path = path.replace('en.', 'jp.');
                        break;
                    case 'es-ES':
                        path = path.replace('en.', 'sp.');
                        break;
                    case 'pt-PT':
                        path = path.replace('en.', 'pt.');
                        break;
                    case 'pt-BR':
                        path = path.replace('en.', 'br.');
                        break;
                    case 'hi-IN':
                        path = path.replace('en.', 'hi.');
                        break;
                    case 'ar-001':
                        path = path.replace('en.', 'ar.');
                        break;
                    case 'fa-IR':
                        path = path.replace('en.', 'fa.');
                        break;
                    case 'bn-BN':
                        path = path.replace('en.', 'bn.');
                        break;
                    case 'te-IN':
                        path = path.replace('en.', 'te.');
                        break;
                    default:
                        break;
                }
            }
            setImage(<img src={path} />);
            setShow(true);
        } else {
            setShow(false);
        }
    }, [currentNotice, i18n.language]);
    const setRead = () => {
        if (currentNotice) {
            localStorage.setItem(
                `${currentNotice.key}_${Username}`,
                READ_STRING
            );
        }
    };
    const handleClose = () => {
        setRead();
        setShow(false);
    };
    const gotoNewUI = () => {
        setRead();
        dispatch(routeSliceActions.goto(ROUTE_NEW_UI));
    };
    return (
        <>
            {show && (
                <div className="new-ui-popup">
                    <Grid className="new-ui-container">
                        <Stack>
                            <Grid className="new-ui-header">
                                <IconButton
                                    sx={{
                                        height: '2.333rem',
                                        width: '2.333rem',
                                    }}
                                    onClick={handleClose}
                                >
                                    <PopupCloseIcon />
                                </IconButton>
                            </Grid>
                            <div className="new-ui-try-button">
                                <IconButton
                                    sx={{ height: '100%', width: '100%' }}
                                    onClick={gotoNewUI}
                                >
                                    {image}
                                </IconButton>
                            </div>
                            {/* <Stack>
                                <Checkbox
                                    label="new_ui.skip_popup"
                                    isChecked={isChecked}
                                    setIsChecked={setIsChecked}
                                />
                            </Stack> */}
                        </Stack>
                    </Grid>
                </div>
            )}
        </>
    );
};
